<template>
  <div class="" v-resize="onResize">
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSuppliers.title') }}
      <v-btn
          color="success"
          class="ml-1 green-shadow"
          x-small
          fab
          max-width="26"
          max-height="26"
          @click="supplierWindow.isVisible = true"
          :title="$t('common.add')"
          :disabled="!fetched"
          :loading="!fetched"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h3>
    <v-toolbar elevation="0" dense rounded class="mt-3">
      <v-toolbar-items>
        <v-btn small text :to="{name:'suppliers'}" exact>{{ $t('viewSuppliers.title') }}</v-btn>
        <v-btn small text :to="{name:'pricelists'}"> {{ $t("viewSupplierPricelists.title") }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-data-table
      ref="suppliersTable"
      :headers="suppliersCarsTableHeader"
      :items="suppliers"
      :height="tableHeight"
      class="elevation-0 mb-3"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item.is_enabled_search_by_pricelists="{ item }">
        <v-simple-checkbox
          :aria-readonly="true"
          :value="!!item.is_enabled_search_by_pricelists"
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.is_available_by_suppliers_api="{ item }">
        <!--        смотрим ли включен ли в API этот поставщик-->
        <div
          v-if="
            suppliersFromAPI.find(
              (s) => s && s.platform_supplier_id === item.id
            )
          "
        >
          <span v-if="suppliersFromAPI.find(
              (s) => s && s.platform_supplier_id === item.id
            )">
             <template v-if="suppliersFromAPI.find(
              (s) => s && s.platform_supplier_id === item.id
            ).config.active">
                    <v-icon color="success" text-color="success" left
                    >fa-check-circle</v-icon
                    >
                  </template>
                  <template v-else>
                    <v-icon color="red" text-color="red" left
                    >fa-times-circle</v-icon
                    >
                  </template>
          </span>
        </div>
      </template>
      <template v-slot:item.suppliers_api_code="{ item }">
        <div
          v-if="
            suppliersFromAPI.find(
              (s) => s && s.platform_supplier_id === item.id
            )
          "
        >
          <img
            height="30px;"
            :src="
              suppliersFromAPI.find(
                (s) => s && s.platform_supplier_id === item.id
              ).logo
            "
          />
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <span class="btn-td-wrap">
          <v-btn
            elevation="0"
            min-width="36"
            min-height="36"
            color="primary"
            class="mb-0 ml-3 px-0 white--text"
            @click="
              supplierWindow.supplierId = item.id;
              supplierWindow.isVisible = true;
            "
            :title="$t('common.edit')"
            :disabled="!fetched"
            :loading="!fetched"
          >
            <v-icon small>$pencil</v-icon>
          </v-btn>
          <v-btn
            elevation="0"
            min-width="36"
            min-height="36"
            @click="remove(item)"
            color="red lighten-2"
            class="mb-0 ml-3 px-0 white--text"
            :title="$t('common.remove')"
            :disabled="!fetched"
            :loading="!fetched"
          >
            <v-icon small>$trash</v-icon>
          </v-btn>
        </span>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <supplier-window
      :supplier-id="supplierWindow.supplierId"
      :show="supplierWindow.isVisible"
      @hide="
        supplierWindow.isVisible = false;
        supplierWindow.supplierId = null;
      "
    />
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import SupplierWindow from "@/components/supplier/SupplierWindow";
import i18n from "@/i18n";

export default {
  components: { SupplierWindow },
  mixins: [CommonMixin],
  data: () => ({
    supplierWindow: {
      isVisible: false,
      supplierId: null,
    },
    tableHeight: "100",
    customer: null,
    customerId: null,
    itemForMaintenanceSearch: null,
    customerEditForm: false,
    maintenancePartsForm: false,
    carEditForm: false,
    customerTypeFilter: null,
    garageDialog: false,
    customerCreateForm: false,
  }),
  mounted() {
    if(this.isApiSuppliersConfigVisible){
      this.$store.dispatch("suppliers/getSuppliersByAPIWithConfig");
    }
    this.$store.dispatch("suppliers/get");
  },
  watch: {
    fetched() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
  },
  methods: {
    async remove(item) {
      this.$confirm({
        title: this.$t("common.confirm"),
        text: this.$t("common.confirm_remove"),
        cancelText: this.$t("common.no"),
        acceptText: this.$t("common.yes"),
      }).then(async (y) => {

        let isSavedSupplierByApi = false;
        this.connectedApiSupplierName = item.suppliers_api_code;
        if (item.suppliers_api_code) {
          //отключим в API Suppliers
          let supplierForDisableByApi = this.suppliersFromAPI.find(
            (s) => s.supplier === item.suppliers_api_code
          );

          if (supplierForDisableByApi) {
            supplierForDisableByApi.config.active = false;
            isSavedSupplierByApi = await this.$store.dispatch(
              "suppliers/saveSupplierAPIConfig",
              {
                supplier: supplierForDisableByApi.supplier,
              }
            );
          }
        } else {
          isSavedSupplierByApi = true;
        }
        if (isSavedSupplierByApi) {
          this.$store.dispatch("suppliers/remove", item.id);
        }
      });
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["suppliersTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
  },
  computed: {
    /**
     * это свойство отвечает за сокрытие настроек API поставщиков для не русскоязычных пользователей
     */
    isApiSuppliersConfigVisible(){
      return this.lang === 'ru';
    },
    ...mapFields("suppliers", [
      "fetched",
      "find_string",
      "suppliers",
      "suppliersFromAPI",
    ]),
    suppliersCarsTableHeader() {
      let fields = [
        {
          text: this.$t("common.legal_name"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.inn"),
          value: "inn",
          sortable: false,
        },
        {
          align: "center",
          text: this.$t(
            "viewSuppliers.search_by_pricelist_loaded_for_this_supplier_is_enabled"
          ),
          value: "is_enabled_search_by_pricelists",
          sortable: false,

        },
        {
          text: this.$t("viewSuppliers.is_enabled_search_by_API"),
          value: "is_available_by_suppliers_api",
          sortable: false,
          hideIfHiddenApiSuppliersConfig: true
        },
        {
          text: this.$t("API"),
          value: "suppliers_api_code",
          sortable: false,
          hideIfHiddenApiSuppliersConfig: true
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: 130,
        },
      ];
      if(this.isApiSuppliersConfigVisible){
        return fields;
      } else {
        return fields.filter(el=>!el.hideIfHiddenApiSuppliersConfig);
      }
    },
  },
};
</script>

<style lang="css" scoped>
tr:hover .btn-td-wrap {
  display: block;
}

.btn-td-wrap {
  display: none;
}
</style>
